<sbpro-toast-view aria-live="polite" aria-atomic="true"></sbpro-toast-view><sbf-overlay></sbf-overlay><sbf-size-detector></sbf-size-detector><router-outlet></router-outlet>
